var App = App || {};

App.Base = (function ($) {
    'use strict';

    function init() {
        HashSupport();
        ZagScrollAnimateBars();
    }

    function HashSupport() {

        const Hash = $(location.hash);

        if (Hash.length == 1) {

            if (Hash.attr("data-bs-toggle") == "collapse") {
                const Target = $(Hash.attr("data-bs-target"));
                const Panel = document.getElementById(Target.attr("id"));
                const Collapse = new bootstrap.Collapse(Panel);
                Collapse.show();
            }

            else if (Hash.attr("data-bs-toggle") == "tab") {
                const Tab = new bootstrap.Tab(Hash);
                Tab.show();
            }

            else if (Hash.hasClass("modal")) {
                const Modal = new bootstrap.Modal(Hash);
                Modal.show();
            }
        }
    }

    function ZagScrollAnimateBars() {
        var barParents = $(".bar, .bar-center, .center-bar, .bar-left, .left-bar, .bar-right, .right-bar").parent();

        barParents.ZagScrollAnimate({
            offset: 75,
            targets: [
                { selector: ".bar, .bar-center, .center-bar, .bar-left, .left-bar, .bar-right, .right-bar", type: "animate__bar", stagger: 0 }
            ]
        })

        $(".site-footer-upper-left").ZagScrollAnimate({
            offset: 75,
            targets: [
                { selector: ".site-footer-headline", type: "animate__bar", stagger: 0 }
            ]
        })
    }

    // https://davidwalsh.name/query-string-javascript
    function GetUrlParameter(name) {
        name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
        var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
        var results = regex.exec(location.search);
        return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
    };

    return {
        init: init,
        GetUrlParameter: GetUrlParameter
    };

})(jQuery);

$(function () {
    App.Base.init();
});